<template>
    <v-container class="main-container">
        <v-container style="margin-top: 15px;">
            <v-row>
                <v-col cols="12" xl="6" class="text-h4">お知らせ一覧</v-col>
            </v-row>
        </v-container>

        <!-- 検索エリア -->
        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header color="#F4FEFB">
                </v-expansion-panel-header>
                <v-expansion-panel-content color="#F4FEFB">
                    <form @submit.prevent="search">
                        <v-container>
                            <v-row>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>分類</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <v-select
                                        v-model="searchItem.type"
                                        :items="types"
                                        outlined
                                        clearable
                                        v-disabled-icon-focus
                                        background-color="white"
                                    >
                                    </v-select>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <badge-component tile color="unset">
                                        <label-component>日付</label-component>
                                    </badge-component>
                                </v-col>
                                <v-col cols="12" xl="2">
                                    <date-picker-component v-model="searchItem.created_at_from"></date-picker-component>
                                </v-col>
                                <p class="between-mark" style="padding-top: 25px;">～</p>
                                <v-col cols="12" xl="2">
                                    <date-picker-component v-model="searchItem.created_at_to"></date-picker-component>
                                </v-col>
                                <v-col cols="12" xl="1">
                                    <label-component>
                                        <v-btn color="blue" class="white--text" type="submit" >検索</v-btn>
                                    </label-component>
                                </v-col>
                            </v-row>
                        </v-container>
                    </form>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>

        <div>
            <!-- テーブル -->
            <template>
                <v-pagination v-model="indexInfo.page" :length="indexInfo.pageCount"></v-pagination>
                <v-data-table
                    :headers="headers"
                    :items="items"
                    :page.sync="indexInfo.page"
                    :items-per-page="indexInfo.itemsPerPage"
                    @page-count="indexInfo.pageCount = $event"
                    disable-sort
                    hide-default-footer
                >
                    <template v-slot:body="props">
                        <tr v-for="(item, index) in props.items" :key="index">
                            <td class="item-td" align="center">{{ item.created_at | moment }}</td>
                            <td class="item-td" align="center">{{ types[item.type].text }}</td>
                            <td class="item-td" align="center">{{ item.title }}</td>
                            <td align="center" ><v-btn color="blue" class="white--text" @click="clickDetail(item)">詳細</v-btn></td>
                        </tr>
                    </template>
                </v-data-table>
            </template>
        </div>

        <template>
            <v-dialog v-model="detailDialog" width="1000" class="common-dialog">
                <v-card color="#F4FEFB">
                    <v-card-title class="justify-left text-h5">{{ title }}</v-card-title>
                        <v-card-text class="common-dialog-message5" >
                        <v-container>
                            <v-row class="text-left">
                                <v-col cols="12" xl="12">
                                    <p class="text--primary">{{ details }}</p>
                                </v-col>
                            </v-row>
                            <v-row class="text-right">
                                <v-col cols="12" xl="12">
                                    <p class="text--primary">日付　{{ created_at | moment }}</p>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions class="justify-center grey lighten-4 pb-6">
                        <v-btn min-width="150px" class="white--text" color="blue-grey lighten-1" large @click="detailDialog = false">
                            閉じる
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </v-container>
</template>

<script>
    import moment from "moment";
    export default {
        data() {
            return {
                // 項目一覧
                items: [],
                title: '',
                details: '',
                created_at: '',
                // 分類
                types: [],
                // 検索項目
                searchItem: {
                    type: '',
                    created_at_from: '',
                    created_at_to: '',
                },
                indexInfo: {
                    // ページ数
                    page: 1,
                    // 最大ページ数
                    pageCount: 0,
                    // 1ページあたりの項目数
                    itemsPerPage: 10,
                },
                // ソート、ページネーション
                options: {},
                // テーブルヘッダー
                headers: [
                  { text: '日付', align: 'center', value: 'created_at' },
                  { text: 'タイプ', align: 'center', value: 'type' },
                  { text: 'タイトル', align: 'center', value: 'title' },
                  { text: '', value: 'action', sortable: false },
                ],
                // 詳細 開閉フラグ
                detailDialog: false,
           };
        },
        methods: {
            // 詳細ボタン押下
            clickDetail(item) {
                this.detailDialog = true;
                this.title = item.title;
                this.details = item.details;
                this.created_at = item.created_at;
            },
            // 検索
            search() {
                axios.post('/documents/search-notifications', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.types = res.data.types;
                });
            },
            // 再検索
            reSearch(msg) {
                axios.post('/documents/search-notifications', this.searchItem).then((res) => {
                    this.items = res.data.items;
                    this.types = res.data.types;
                    this.messageDialog = true;
                    this.msg = msg;
                });
            },
        },
        // 日付フォーマット
        filters: {
            moment(date) {
                return moment(date).format('YYYY/MM/DD hh:mm');
            },
        },
        // 初期表示のデータ
        mounted() {
            axios.get('/documents/get-notifications').then(res => {
                this.items = res.data.items;
                this.types = res.data.types;
            });
        }
    };
</script>

<style scoped lang="scss">
    @import '../../../sass/app.scss';
    .notice-icon {
        margin-right: 10px !important;
    }

    .main-container {
        font-family: $body-font-family;
    }

    .main-content-area {
        margin-top: 10px;
    }

    .common-dialog-message {
        color: black !important;
    }

    /* table */
    .v-btn:not(.v-btn--round).v-size--default {
        margin: 2px 0;
    }
    td {
        border-bottom: solid 1px rgb(0, 0, 0, 0.05);
    }

    /* 検索エリア */
    .v-expansion-panels {
        margin: 10px 0;
    }
    .v-expansion-panel-content__wrap {
        padding-bottom: 0;
    }
</style>